module.exports = __webpack_public_path__ + "img/clir-full-long.ea4b6f82.svg";